function resolveResultScreen(screen, result, username, gameId) {
  if (screen !== 'gameOver' || result) return screen;
  if (!username) return 'login';
  return gameId ? 'game' : 'myGames';
}

module.exports = { resolveResultScreen };
